import React from "react";
import { RouteObject } from "../../interfaces/navigation";
import { Navigate } from "react-router-dom";

const EntryPoint = React.lazy(() => import("../../containers/Search/SearchContainer")) as React.LazyExoticComponent<React.ComponentType<any>>;

export const searchRoutes: RouteObject[] = [
    {
        title: "Search Redirect",
        path: "/buscar",
        component: <Navigate to="/buscar/autos/usados" replace />
    },
    {
        title: "Search Autos Redirect",
        path: "/buscar/autos",
        component: <Navigate to="/buscar/autos/usados" replace />
    },
    {
        title: "Search with Filters",
        path: "/buscar/autos/usados/*",
        component: <EntryPoint/>
    },
    {
        title: "Search with Filters",
        path: "/buscar/autos/nuevos/*",
        component: <EntryPoint/>
    },
    {
        title: "Search Comerciales Redirect",
        path: "/buscar/comerciales",
        component: <Navigate to="/buscar/comerciales/usados" replace />
    },
    {
        title: "Search Comerciales Usados",
        path: "/buscar/comerciales/usados/*",
        component: <EntryPoint/>
    },
    {
        title: "Search Comerciales Nuevos",
        path: "/buscar/comerciales/nuevos/*",
        component: <EntryPoint/>
    },
];